import styled from 'styled-components';

export const Content = styled.div`
  background-color: #182736;
  /* box-shadow: 0px 4px 8px rgba(20, 46, 82, 0.2); */
  border-radius: 4px;
`;

export const ContainerTabs = styled.div`
  padding: 5px 30px 20px 30px;
`;

export const HeaderContainer = styled.div`
  height: 50px;
  border-bottom: '1px solid #8B99A7';
`;

export const HeaderContent = styled.div`
  padding: 5px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
